import { Card } from "@/shared/ui/card.tsx"
import { EventAttributesType, BrandAttributesType } from "../api/play-api"
import ResultDetail from "./ResultDetail"

type AttributesProps = {
  brandAttributes: BrandAttributesType,
  eventAttributes: EventAttributesType
}

const Attributes = ({brandAttributes, eventAttributes}: AttributesProps) => {
  return (
    <>
      <h2 className="text-3xl font-montserrat pt-3">Brand Specific Data</h2>
      {(Object.keys(brandAttributes) as (keyof BrandAttributesType)[])
        .filter((key) => !['id', 'event_name', "event_id"].includes(key))
        .map((data) => (
          <ResultDetail
            key={data}
            label={data.replace(/(^\w|_\w)/g, match => match.replace('_', ' ').toUpperCase())}
            content={brandAttributes[data]}
          />
        ))}
      <h2 className="text-3xl font-montserrat pt-3">Event Specific Data</h2>
      <Card className="flex flex-col gap-1 p-3 my-2">
        <p className="text-lg text-gray-700 ">Content Performance</p>
        <p className="text-sm text-gray-700">Event Performance : <span className="text-gray-500">{JSON.parse(eventAttributes.content_performance).event_performance}</span></p>
        <p className="text-sm text-gray-700">Content Performance : <span className="text-gray-500">{JSON.parse(eventAttributes.content_performance).content_performance}</span></p>
        <p className="text-sm text-gray-700">Platform Performance : <span className="text-gray-500">{JSON.parse(eventAttributes.content_performance).platform_performance}</span></p>
      </Card>
      {(Object.keys(eventAttributes) as (keyof EventAttributesType)[])
        .filter((key) => !['id', 'event_name', "event_id", "content_performance"].includes(key))
        .map((data) => (
          <ResultDetail
            key={data}
            label={data.replace(/(^\w|_\w)/g, match => match.replace('_', ' ').toUpperCase())}
            content={eventAttributes[data]}
          />
        ))}
    </>
  )
}

export default Attributes
